// Settings sync service - loads cloud settings into the active user scope.
import { supabase } from "@/integrations/supabase/client";
import { UserSettings } from "./userSettings";

// Load settings from Supabase and merge with localStorage
export async function loadSettingsFromSupabase(userId: string): Promise<Partial<UserSettings> | null> {
  try {
    const { data, error } = await supabase
      .from("user_settings")
      .select("*")
      .eq("user_id", userId)
      .maybeSingle();

    if (error) {
      console.error("[settingsSync] Error loading settings:", error);
      return null;
    }

    if (!data) {
      return null;
    }

    // Map database columns back to UserSettings
    return {
      name: data.name || "",
      gender: (data.gender as "male" | "female" | "neutral") || "male",
      voiceGender: (data.voice_gender as "male" | "female") || "female",
      language: data.language || "he",
      theme: (data.theme as "light" | "dark" | "auto") || "dark",
      isMuted: data.is_muted || false,
      speechRate: data.speech_rate || 1.0,
      controlMethod: data.control_method || "standard_pointer",
      scanMode: (data.scan_mode as "cell_by_cell" | "row_and_column") || "cell_by_cell",
      scanSpeed: (data.scan_speed || 3000) / 1000, // Convert from milliseconds
      externalSwitchScanType: (data.scan_type as "automatic" | "manual") || "automatic",
      externalSwitchCount: data.external_switch_count || 1,
      helpAlertType: (data.help_alert_type as any) || "voice",
      clonedVoiceId: data.cloned_voice_id || null,
      useClonedVoice: data.use_cloned_voice || false,
      nightMonitoringEnabled: data.night_monitoring_enabled || false,
      nightMonitoringStartTime: data.night_monitoring_start_time || "22:00",
      nightMonitoringEndTime: data.night_monitoring_end_time || "06:00",
      nightMonitoringDuration: data.night_monitoring_duration || 5,
      caregiverEmail: data.caregiver_email || null,
    };

  } catch (error) {
    console.error("[settingsSync] Unexpected error loading settings:", error);
    return null;
  }
}
